import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

export interface EmptyMessagesListProps {
  title: string;
  subtitle: string;
  items?: { icon: ReactNode; text: string }[];
}

export const EmptyMessagesList = (props: EmptyMessagesListProps) => {
  const { title, subtitle, items } = props;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'column',
        gap: 2,
        my: 2.5,
        px: 2,
        maxWidth: 860,
      }}
    >
      <Typography variant='h5' sx={{ fontWeight: 700, color: 'text.secondary' }}>
        {title}
      </Typography>
      <Typography variant='body'>{subtitle}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 2 }}>
        {items?.map(({ icon, text }) => (
          <Box key={text} sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'flex-start' }}>
            <Box sx={{ color: 'text.secondary', lineHeight: 0 }}>{icon}</Box>
            <Typography variant='bodySmall' sx={{ flex: 1 }}>
              {text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
